{
  "assetType": {
    "stocks": "Акции",
    "options": "Опционы"
  }
}
